var map = {
	"./abrasion.png": "b504",
	"./bruise.png": "2dc7",
	"./cavity.png": "d9ec",
	"./chip.png": "c61d",
	"./cloud.png": "2529",
	"./crystal.png": "f302",
	"./etch_channel.png": "2a52",
	"./extra_facet.png": "78bf",
	"./feather.png": "5066",
	"./feather_filled.png": "f458",
	"./indented_natural.png": "8020",
	"./internal_graining.png": "e909",
	"./internal_laser_drill.png": "3978",
	"./knot.png": "7f3d",
	"./laser_drill_hole.png": "4243",
	"./natural.png": "ee62",
	"./needle.png": "ef8a",
	"./nick.png": "345e",
	"./pinpoint.png": "fa96",
	"./pit.png": "0817",
	"./polish_lines.png": "b50c",
	"./scratch.png": "8ba6",
	"./surface_graining.png": "2a4b",
	"./twinning_wisp.png": "0fb1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4659";